export default "__VITE_ASSET__DTmFCCeL__"